export default __webpack_public_path__ + "static/media/stadium-bg-main.034aa6f5.svg";